import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = {};

// iter318 — presentation-only workspace (role Menu Groups + base level). Never grants access.
export function useWorkspace() {
  const { user } = useAuth();
  const uid = user?._id || user?.id || '';
  const [ws, setWs] = useState(cache[uid] || null);
  useEffect(() => {
    if (!uid) return;
    let live = true;
    axios.get(`${API}/me/workspace`, { withCredentials: true })
      .then(({ data }) => { cache[uid] = data; if (live) setWs(data); })
      .catch(() => { if (live) setWs({ nav_groups: [], full_navigation: true, base_level: '' }); });
    return () => { live = false; };
  }, [uid]);
  return ws;
}

// Menu Group → sidebar paths that belong to it (presentation grouping only).
export const NAV_GROUP_PATHS = {
  office_work: ['/admin/dashboard'],
  schedule: ['/admin/schedule'],
  customers: ['/admin/customers'],
  billing: ['/admin/invoices', '/admin/estimates', '/admin/billing', '/admin/memberships'],
  workforce: ['/admin/workforce', '/admin/users'],
  inventory: ['/admin/inventory', '/admin/assets'],
  field_tools: ['/admin/field-notes', '/admin/service-requests', '/admin/followups'],
  admin_system: ['/admin/settings', '/admin/departments', '/admin/divisions', '/admin/roles', '/admin/service-types'],
};
